import React from 'react';
import { ErrorHeaderTh, FieldTd, tableStyleBase, tableStyleErrorBase, ValueTd } from 'components/account/jobs-v2/dropdowns/IdDocument/utils';
export const IdNameMismatchDetails = ({ hasNameMatchError, identityName, submittedName, customStyles }) => {
    if (!hasNameMatchError || !identityName) {
        return null;
    }
    return (React.createElement("table", { style: { ...tableStyleBase, ...tableStyleErrorBase, ...customStyles } },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement(ErrorHeaderTh, { width: "25%" }, "Field"),
                React.createElement(ErrorHeaderTh, { width: "40%" }, "ID"),
                React.createElement(ErrorHeaderTh, { width: "40%" }, "Submitted")),
            React.createElement("tr", null,
                React.createElement(FieldTd, null, "Name"),
                React.createElement(ValueTd, null, identityName),
                React.createElement(ValueTd, null, submittedName)))));
};
